import { Box, Tooltip } from "src/mui";
import { styled } from "@mui/material";
import type { TooltipProps } from "src/mui";
import { tooltipClasses } from "@mui/material/Tooltip";
import { Link } from "react-router-dom";

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        display: flex;
        width:200;
        text-decoration: none;
        font-weight: ${theme.typography.fontWeightBold};
`
);

const TooltipWrapper = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.colors.alpha.trueWhite[100],
    color: theme.palette.getContrastText(theme.colors.alpha.trueWhite[100]),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: "bold",
    borderRadius: theme.general.borderRadiusSm,
    boxShadow:
      "0 .2rem .8rem rgba(7,9,25,.18), 0 .08rem .15rem rgba(7,9,25,.15)",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.colors.alpha.trueWhite[100],
  },
}));

function Logo({ width = "80%" }: { width?: number | string }) {
  return (
    <TooltipWrapper disableHoverListener title="Millwoods" arrow>
      <LogoWrapper to="/">
        <Box
          component="img"
          sx={{ width: width, objectFit: "contain" }}
          alt="Millwoods Travels"
          src={"/assets/brand/logo-white.webp"}
        />
      </LogoWrapper>
    </TooltipWrapper>
  );
}

export default Logo;
